export default "__VITE_ASSET__fda07df4__"